import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ServiceProvidersService } from 'src/services/service-providers.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
enum AutoCompleteFilterEnum {
  SERVICE_PROVIDERS = 'serviceProviders',
}
@Component({
  selector: 'app-input-subject-in-service-provider',
  templateUrl: './input-subject-in-service-provider.component.html',
  styleUrls: ['./input-subject-in-service-provider.component.scss']
})
export class InputSubjectInServiceProviderComponent implements OnInit {
  serviceProviderFormAdd: FormGroup;
  serviceProviders: any;
  providedServices: any;
  filteredServiceProviders: Observable<any[]>;
  displayServiceProvider = (item: any) => item?.name || item;

  constructor(private formBuilder: FormBuilder, 
    public dialogRef: MatDialogRef<any>, 
    public dialog: MatDialog, 
    private serviceProvidersService: ServiceProvidersService
  ) 
  { }

  ngOnInit(): void {
    this.serviceProviderFormAdd = this.formBuilder.group({
      serviceProvider: [null, Validators.required],
      providedService: [null, Validators.required],
      rightGrantedDate: [null, Validators.required]
    });

    this.serviceProvidersService.getAllServiceProviders().subscribe(result => {
      this.serviceProviders = result || [];

      this.filteredServiceProviders = this.serviceProviderFormAdd.controls.serviceProvider.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value.title)),
        map(title => (title ? this._filter(title, AutoCompleteFilterEnum.SERVICE_PROVIDERS) : this.serviceProviders.slice())),
      );
    });

    this.serviceProviderFormAdd.get('serviceProvider')?.valueChanges.subscribe(value => {
      if (value && typeof value !== 'string') {
        this.loadProvidedServices(value.id);
      } else {
        this.providedServices = [];
        this.serviceProviderFormAdd.controls.providedService.reset();
      }
    });
  }

  loadProvidedServices(serviceProviderId: any) {
    this.serviceProvidersService.findProvidedServicesByServiceProviderId(serviceProviderId).subscribe({
      next: (result) => {
        this.providedServices = result || [];
        this.serviceProviderFormAdd.controls.providedService.reset();
      },
      error: () => {
        this.providedServices = [];
        this.serviceProviderFormAdd.controls.providedService.reset();
      }
    });
  }

  sendRequest() {
    const formValue = this.serviceProviderFormAdd.value;

    const payload = {
      ...formValue,
      serviceProvider: formValue.serviceProvider?.id
    };

    this.dialogRef.close({ event: 'success', data: payload });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'cancel' });
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  private _filter(value: string, what: AutoCompleteFilterEnum): any[] {
    const filterValue = value.toLowerCase();

    return (this.serviceProviders || []).filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  checkServiceProvider(fast: boolean) {
    if (fast === false) {
      setTimeout(() => this.validateServiceProvider(), 300);
    } else {
      this.validateServiceProvider();
    }
  }

  private validateServiceProvider() {
    const control = this.serviceProviderFormAdd.get('serviceProvider');
    const value = control.value;

    if (!this.serviceProviders) return;

    if (!value || typeof value === 'string') {
      const search = (value || '').toLowerCase();

      const found = this.serviceProviders.filter(sp =>
        sp.name.toLowerCase().includes(search) ||
        sp.id?.toString().includes(search)
      );

      if (found.length === 0) {
        control.setErrors({ notValid: true });
        return;
      }

      control.setValue(found[0]);
      control.setErrors(null);

      this.loadProvidedServices(found[0].id);
    }
  }

}
